var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFileWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m212.4 115.2v969.6h775.2v-728.4l-258-241.2zm703.2 897.6h-631.2v-825.6h398.4v223.2h232.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600 476.4-67.199 135.6-150 22.801 108 105.6-25.199 148.8 134.4-69.598 134.4 69.598-26.398-148.8 109.2-105.6-150-22.801z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFileWhite);
export default __webpack_public_path__ + "static/media/star-file-white.b9db6baa266c8621080c72e56417b9f6.svg";
export { ForwardRef as ReactComponent };